import gql from "graphql-tag";

export default gql`
  mutation createAsset($assetInput: AssetInputInput, $customerId: ID) {
    createAsset(assetInput: $assetInput, customerId: $customerId) {
      id
      customerId
    }
  }
`;

export const createCommonAssetMutation = gql`
  mutation createCommonAsset($assetInput: AssetInputInput, $customerId: ID) {
    createCommonAsset(assetInput: $assetInput, customerId: $customerId) {
      id
      customerId
    }
  }
`;
